import { Alert } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import ReportErrorButton from "components/FeedbackProvider/ReportErrorButton";
import useNotifications from "./hooks/useNotifications";

export default function GlobalNotifications() {
  const { props } = useNotifications();
  const {
    action,
    message,
    errors,
    severity,
    variant = "filled",
    onClose,
    ...snackbarProps
  } = props;

  return (
    <Snackbar {...snackbarProps} onClose={onClose}>
      <Alert
        onClose={onClose}
        severity={severity}
        variant={variant}
        action={action}
      >
        {message}
        {errors && <ReportErrorButton sx={{ ml: 2 }} errors={errors} />}
      </Alert>
    </Snackbar>
  );
}
